<template>
  <Dialog v-model:open="isModalOpen" class="mx-auto">
    <DialogContent
      class="!rounded-none md:!rounded-3xl max-w-[800px] md:w-11/12 w-full p-0 border-none h-full md:h-auto !bg-transparent"
      @interact-outside="(e) => e.preventDefault()"
    >
      <div class="flex min-h-full items-center justify-center mx-6">
        <div
          class="w-full sm:max-w-xl md:max-w-3xl lg:max-w-max bg-white px-8 py-6 rounded-xl relative"
        >
          <div
            class="bg-white rounded-lg h-8 w-8 absolute top-0 -right-10 flex justify-center items-center cursor-pointer"
            @click="isModalOpen = false"
          >
            <Icon class="w-5 h-5" icon="mingcute:close-fill"></Icon>
          </div>
          <div class="flex flex-col gap-y-1">
            <span class="text-heading-sm">Generations</span>
            <span class="text-body-md text-text-secondary">
              See and download your generations at an instant
            </span>
          </div>
          <div
            class="mt-6 border border-border-primary p-6 flex gap-x-6 rounded-xl bg-background-secondary"
          >
            <div
              class="w-[500px] flex justify-center max-w-[500px] max-h-[500px] overflow-hidden bg-black/70 rounded-xl"
            >
              <AdvanceVideo
                autoplay
                muted
                controls
                class="rounded overflow-hidden"
                video-class="h-full w-auto h-[500px]"
                container-class="h-full"
                :aspect-ratio="1.0"
                :src="selectedModalData?.downloadUrl"
              />
            </div>
            <div class="flex flex-col justify-between gap-y-4">
              <div>
                <Button
                  class="text-sm flex gap-x-2 w-full"
                  @click="handleDownload"
                >
                  <span>Download</span>
                  <Icon
                    v-if="downloadLoader"
                    icon="svg-spinners:ring-resize"
                  ></Icon>
                  <Icon v-else icon="solar:download-minimalistic-linear"></Icon>
                </Button>
                <div
                  class="max-w-52 w-max lg:min-w-52 border border-border-primary rounded-lg py-4 px-5 mt-5 flex flex-col gap-y-4 bg-white"
                >
                  <div
                    v-if="selectedModalData?.prompt"
                    class="flex flex-col gap-y-1"
                  >
                    <span class="text-text-secondary text-sm">Prompt:</span>
                    <span class="text-sm">
                      {{ selectedModalData?.prompt }}
                    </span>
                  </div>
                  <div class="flex flex-col gap-y-1">
                    <span class="text-text-secondary text-label-lg">
                      Credits:
                    </span>
                    <span class="text-label-lg">10</span>
                  </div>
                  <!-- <div class="flex flex-col gap-y-1">
                    <span class="text-text-secondary text-label-lg">
                      Stored Till:
                    </span>
                    <span class="text-label-lg">
                      {{ getExpiryDate(selectedModalData?.timestamp, 1) }}
                    </span>
                  </div> -->
                </div>
              </div>
              <div
                class="w-14 border border-border-primary rounded-lg p-3 bg-white ml-auto"
              >
                <img
                  :src="selectedModalData?.thumbnail"
                  alt="original image"
                  class="rounded-sm overflow-hidden"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { DialogContent, Dialog } from "@/components/ui/dialog";
import { Icon } from "@iconify/vue";
import Button from "@/components/ui/button/Button.vue";
import { openAIVideoModal, closeAIVideoModal } from "@/lib/utils.js";
import { useSubscription } from "@vueuse/rxjs";
import { downloadVideoFromUrl } from "@/util/common.util";
import AdvanceVideo from "@/components/common/AdvanceVideo.vue";

const isModalOpen = ref(false);
const downloadLoader = ref(false);

const props = defineProps({
  selectedModalData: {
    type: Object,
    default: () => {},
  },
});

useSubscription(
  closeAIVideoModal.subscribe(() => {
    isModalOpen.value = false;
  }),
);

useSubscription(
  openAIVideoModal.subscribe(() => {
    isModalOpen.value = true;
  }),
);

const handleDownload = async () => {
  downloadLoader.value = true;
  try {
    if (
      props.selectedModalData?.downloadUrl &&
      props.selectedModalData?.downloadUrl.startsWith(
        "https://assets.mockey.ai",
      )
    ) {
      await downloadVideoFromUrl(
        props.selectedModalData.downloadUrl,
        props.selectedModalData?.prompt,
      );
    }
  } catch (error) {
    if (props.selectedModalData.downloadUrl) {
      window.open(props.selectedModalData.downloadUrl, "_blank");
    }
  } finally {
    downloadLoader.value = false;
  }
};
</script>
